import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FeatureFlagService } from 'projects/money-movement-ui/src/app/shared/services/feature-flag-service';
import { Subject, takeUntil } from 'rxjs';
import { createControl } from '../../../utilities/formUtilities';
import { CheckTransactionDetailsForm } from '../../../models/form/TransactionFormGroup';

@Component({
  standalone: false,
  selector: 'mm-check-payee-type',
  templateUrl: './check-payee-type.component.html',
  styleUrls: ['./check-payee-type.component.scss'],
})
export class CheckPayeeTypeComponent implements OnInit, OnDestroy {
  @Input() parentForm!: FormGroup<CheckTransactionDetailsForm>;
  @Input() isFirstPartyModified: boolean;
  @Input() recipientAddressType: string;
  @Input() isFromEditTable: boolean;
  @Input() shouldDisableFieldForEditQcd: boolean = false;
  controlName: string = 'payeeType';
  title: string = 'Payee';
  errorText: string = 'Select a payee';
  destroy$: Subject<boolean> = new Subject();
  constructor(private store: Store, private ffs: FeatureFlagService) { }

  ngOnInit(): void {
    createControl(this.parentForm, this.controlName, '', [Validators.required], undefined, this.shouldDisablePayeeType());
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  shouldDisablePayeeType(): boolean {
    return (
      (this.isFromEditTable &&
      this.isFirstPartyModified &&
      this.recipientAddressType === 'addressofrecord') ||
      this.shouldDisableFieldForEditQcd
    );
  }

  get hasError(): boolean {
    const control = this.parentForm?.controls['payeeType'];
    if (control?.disabled) {
      return (typeof control?.validator === 'function') && Object.keys(control.validator(control) ?? []).length > 0;
    }
    if (control?.touched) {
      return control?.invalid ?? false
    }
    return false;
  }
}
